export default __webpack_public_path__ + "static/char-s-53-zh-Hans-9d028f72a99a5d823e6c9222ac870fdb.webp";